<template>
  <l-fixed-window>
    <template slot="fixed-top" v-if="inList">
      <v-tabs :class="dark ? 'grey darken-3':'white'" class="px-4" v-model="tabs">
        <v-tab :value="i" :key="i" v-for="(t, i) in tabItems" :disabled="!t.to" @click="replaceTab(t)">{{t.label}}</v-tab>
      </v-tabs>
      <v-divider></v-divider>
    </template>
    <parent-view cache-all></parent-view>
  </l-fixed-window>
</template>

<script>
let nameSet = new Set([
  'TeacherList',
  'BachelorList',
  'MasterList',
  'JjsList',
  'ZjsList',
  'PartnerList'
])
export default {
  name: 'UserRegister',
  computed: {
    dark () {
      return this.$vuetify.dark
    },
    inList () {
      return nameSet.has(this.$route.name)
    }
  },
  data () {
    return {
      tabs: -1,
      tabItems: [
        {
          label: '教职工',
          to: '/user-admin/user/register/teacher'
        },
        {
          label: '本科生',
          to: '/user-admin/user/register/bachelor'
        },
        {
          label: '硕士生',
          to: '/user-admin/user/register/master'
        },
        {
          label: '继教生',
          to: '/user-admin/user/register/jjs'
        },
        {
          label: '终教生',
          to: '/user-admin/user/register/zjs'
        },
        {
          label: '一卡通',
          to: ''
        },
        {
          label: '合作用户',
          to: '/user-admin/user/register/partner'
        }
      ]
    }
  },
  methods: {
    replaceTab (t) {
      this.$L.tab.replace(t.to)
    }
  },
  activated () {
    let t = this.tabItems.find(t => t.to === this.$route.path)
    if (t) {
      this.tabs = this.tabItems.indexOf(t)
    }
  }
}
</script>

<style scoped>

</style>
